const todoReducer = (todos = [], action) => {
  console.log(action);
  switch (action.type) {
    case "ADD-TODO":
      if (action.payload.name) {
        return [
          ...todos,
          { id: Date.now(), name: action.payload.name, complete: false },
        ];
      }
      return todos;
    case "TOGGLE-TODO":
      return todos.map((todo) => {
        if (todo.id === action.payload.id) {
          return { ...todo, complete: !todo.complete };
        }
        return todo;
      });
    case "REMOVE-TODO":
      return todos.filter((todo) => todo.id !== action.payload.id);
    default:
      return todos;
  }
};

export default todoReducer;
